<!-- Figma 28520:21850: the pack on both devices, the stub payment card on the right. -->
<div class="order-layout" *ngIf="job">
  <section class="order-main">
    <h1 class="flow-title">Your work. <span class="rf-nowrap">Ready to go.</span></h1>
    <p class="flow-subtitle"><span class="rf-name-with">“<span class="rf-name" [title]="job.name">{{ job.name }}</span>”</span> video pack.<br>${{ price }} for both finished videos&ensp;<ng-container *ngFor="let part of videoSpec; let last = last"><span class="rf-nowrap">{{ part }}{{ last ? '' : ' ·' }}</span>{{ last ? '' : ' ' }}</ng-container></p>

    <div class="order-devices">
      <app-render-still-devices *ngIf="job.preview as preview" [landscape]="preview.landscape" [portrait]="preview.portrait" [name]="job.name"></app-render-still-devices>
    </div>
  </section>

  <aside class="order-card order-card--checkout">
    <h2>Complete your pack.</h2>
    <p class="order-card__lead">Payment will open Stripe Checkout once it is connected. This screen stands in for it.</p>

    <div class="payment-feedback" role="alert">
      <div *ngIf="job.checkoutError === 'declined'" class="rf-notice rf-notice--error">
        <strong>The payment was declined.</strong>No payment was taken. Try again to continue.
      </div>
      <div *ngIf="job.checkoutError && job.checkoutError !== 'declined'" class="rf-notice rf-notice--error">
        <strong>The payment did not go through.</strong>{{ job.checkoutError }}
      </div>
      <div *ngIf="error" class="rf-notice rf-notice--error">{{ error }}</div>
    </div>

    <!-- The Figma's empty card: where Stripe's form will sit. -->
    <div class="stub-card">
      <strong>Stub payment · ${{ price }}.00 USD</strong>
      <small>No card details needed or collected. No real charge will be made.</small>
    </div>

    <button class="rf-button order-card__cta" type="button" [disabled]="paying" (click)="onPay()">{{ paying ? 'Confirming payment…' : 'Pay $' + price + ' (stub)' }}</button>
    <button class="rf-text-link order-card__back" type="button" [disabled]="paying" (click)="onBack()">Back to my preview</button>
  </aside>
</div>
